import LocalStorage from '../utils/localStorage';
import fileSaver from '../utils/lib/fileSaver.min';

const urlDaApi = process.env.URL_BASE;

export default class Download {
  constructor() {
  }

  realizarDownloadDeDocumentosComTratamentoDeErro(TipoDaRequisicao, url, parametros, successCallback, errorCallback) {
    $.ajaxTransport('+binary', (options, originalOptions, jqXHR) => {
      if (window.FormData && ((options.dataType && (options.dataType == 'binary')) || (options.data && ((window.ArrayBuffer && options.data instanceof ArrayBuffer) || (window.Blob && options.data instanceof Blob))))) {
        return {
          send(headers, callback) {
            let xhr = new XMLHttpRequest(),
              type = options.type,
              async = options.async || true,
              dataType = options.responseType || 'blob',
              data = options.data || null,
              username = options.username || null,
              password = options.password || null;

            xhr.addEventListener('load', () => {
              const data = {};
              data[options.dataType] = xhr.response;
              callback(xhr.status, xhr.statusText, data, xhr.getAllResponseHeaders());
            });

            xhr.open(type, `${urlDaApi}${url}`, async, username, password);

            for (const i in headers) {
              xhr.setRequestHeader(i, headers[i]);
            }

            xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');

            xhr.responseType = dataType;
            xhr.send(data);
          },
          abort() {
            jqXHR.abort();
          },
        };
      }
    });

    $.ajax({
      url: `${urlDaApi}${url}`,
      type: TipoDaRequisicao,
      dataType: 'binary',
      data: parametros,
      beforeSend(xhr) {
        const usuarioLogado = LocalStorage.obter('usuario') || {};
        xhr.setRequestHeader('Authorization', `Bearer ${usuarioLogado.tokenDeAutorizacaoDoKeycloak}`);
      },
      success(response, status, context) {
        if (response.type === 'application/json') {
          const reader = new FileReader();
          reader.onload = function () {
            const mensagens = JSON.parse(reader.result);

            if (mensagens !== undefined) {
              ExibirMensagem(mensagens.excecoes, TipoDeMensagem.Erro);
            }
          };
          reader.readAsText(response);
        } else {
          const nomeDoArquivo = decodeURIComponent(escape(context.getResponseHeader('FileName')));
          fileSaver.saveAs(response, nomeDoArquivo);

          if (successCallback) { successCallback(); }
        }
      },
      error() {
        if (errorCallback) { errorCallback(); }
      },
    });
  }
}


// WEBPACK FOOTER //
// ./src/utils/downloadDeArquivos.js